export const languagesKeys = {
  all: ['languages'],
};
